import React from "react";
import useDarkMode from "../../hooks/useDarkMode";

export default function Logo({
  className = "",
  margin = "hidden md:block lg:ml-24 mt-8 mb-6",
  fontSize = "text-2xl" // Control the overall logo size
}) {
  const mode = useDarkMode();
  const isDark = mode === 'dark';
  
  // Colors based on the current theme
  const primaryColor = isDark ? "#4ade80" : "#16a34a"; // Green
  const secondaryColor = isDark ? "#d8b4fe" : "#9333ea"; // Purple
  
  return (
    <a
      href={process.env.REACT_APP_SB_HOME_URL}
      className={`flex justify-start gap-1 logo ${className} ${fontSize} font-bold items-center`}
    >
      {/* Logo Text with Gradient */}
      <span className={
        isDark 
          ? "bg-gradient-to-r from-green-400 to-purple-400 bg-clip-text text-transparent inline-block"
          : "bg-gradient-to-r from-green-600 to-purple-600 bg-clip-text text-transparent inline-block"
      }>
        TalkingData.ai
      </span>

      {/* Bullhorn Icon with Wave Bars SVG - after text */}
      <span>
      <svg 
        width="5em" 
        height="4em" 
        viewBox="0 0 100 100" 
        className="inline-block"
        style={{ verticalAlign: 'middle' }}
      >
        <g transform="translate(20, 50) scale(0.35)">
          {/* Bullhorn */}
          <path d="M -60,0 L -50,15 L -50,-15 Z" fill={primaryColor} />
          <path d="M -50,15 C -40,20 -20,25 0,20 L 0,-20 C -20,-25 -40,-20 -50,-15 Z" fill={primaryColor} />
          <rect x="-75" y="-6" width="15" height="12" rx="3" fill={primaryColor} />
          
          {/* Bar Chart Sound Waves with Gradient */}
          <defs>
            <linearGradient id="fadeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor={primaryColor} stopOpacity="1" />
              <stop offset="100%" stopColor={secondaryColor} stopOpacity="0.3" />
            </linearGradient>
          </defs>
          
          <rect x="10" y="-30" width="8" height="60" fill="url(#fadeGradient)" />
          <rect x="25" y="-20" width="8" height="40" fill="url(#fadeGradient)" />
          <rect x="40" y="-35" width="8" height="70" fill="url(#fadeGradient)" />
          <rect x="55" y="-15" width="8" height="30" fill="url(#fadeGradient)" />
          <rect x="70" y="-25" width="8" height="50" fill="url(#fadeGradient)" />
        </g>
      </svg>
      </span>
    </a>
  );
}